import { Link } from "react-router-dom";

const CategoryCard = ({ category, compact = false }) => (
  <Link
    to={`/${category.slug}`}
    className="group flex h-full flex-col overflow-hidden rounded-2xl bg-white text-containx-navy shadow-sm ring-1 ring-black/5 transition duration-300 hover:-translate-y-1 hover:shadow-xl"
  >
    <div className={compact ? "h-36 overflow-hidden" : "h-52 overflow-hidden"}>
      <img
        src={category.image}
        alt={`${category.name} from ContainX`}
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
      />
    </div>
    <div className="flex flex-1 flex-col p-5">
      <h3 className="text-xl font-semibold">{category.name}</h3>
      {!compact && <p className="mt-2 text-sm leading-6 text-slate-600">{category.description}</p>}
      <span className="mt-auto pt-4 text-sm font-bold text-containx-tan">
        Browse category <span aria-hidden="true">→</span>
      </span>
    </div>
  </Link>
);

export default CategoryCard;
